module.exports = __webpack_public_path__ + "img/pic.a714e1b7.png";